import { useMutation } from '@apollo/client';

import UpdateDesiredSkills from 'bundles/onboarding-common/queries/UpdateDesiredSkills.graphql';
import type {
  UpdateDesiredSkillsMutation,
  UpdateDesiredSkillsMutationVariables,
} from 'bundles/onboarding-common/queries/__generated__/UpdateDesiredSkills';
import type { Skill } from 'bundles/onboarding-common/types';

const useUpdateDesiredSkills = () => {
  const [updateDesiredSkillsMutation] = useMutation<UpdateDesiredSkillsMutation, UpdateDesiredSkillsMutationVariables>(
    UpdateDesiredSkills,
    {
      context: { clientName: 'gatewayGql' },
      errorPolicy: 'all',
    }
  );

  const updateDesiredSkills = async (skills?: Array<Skill> | null, removeSkills?: boolean) => {
    const desiredSkills = skills?.map((skill) => ({ id: skill.id })) || [];

    const { errors, data } = await updateDesiredSkillsMutation({
      variables: {
        desiredSkills: removeSkills ? { remove: {} } : { desiredSkills },
      },
    });

    if (errors) {
      return errors.map((error) => error.message);
    }

    if (data?.LearnerProfile_PatchSkills.__typename === 'LearnerProfile_PatchFailure') {
      return data?.LearnerProfile_PatchSkills.errors.map((error) => error.message);
    }

    return undefined;
  };

  return {
    updateDesiredSkills,
  };
};

export default useUpdateDesiredSkills;
